{
  "program": [
    {
      "programTypeGuid": "C5D3A897-C737-4EEC-BFC7-D9FF1FB7F315",
      "page": {
        "pageKey": "mrpp-preview",
        "workshop": [
          {
            "workshopTypeId": 10,
            "element": [
              {
                "id": "poeExpirationDays"
              }
            ],
            "model": {
              "poeExpiryDays": 90
            }
          },
          {
            "workshopTypeId": 11,
            "element": [
              {
                "id": "poeExpirationDays"
              }
            ],
            "model": {
              "poeExpiryDays": 90
            }
          },
          {
            "workshopTypeId": 7,
            "element": [
              {
                "id": "poeExpirationDays"
              }
            ],
            "model": {
              "poeExpiryDays": 60
            }
          },
          {
            "workshopTypeId": 8,
            "element": [
              {
                "id": "poeExpirationDays"
              }
            ],
            "model": {
              "poeExpiryDays": 60
            }
          },
          {
            "workshopTypeId": null,
            "element": [
              {
                "id": "poeExpirationDays"
              }
            ],
            "model": {
              "poeExpiryDays": 30
            }
          }
        ]
      }
    }
  ] 
}